@if (tree.getNode(id) !== null && !no_draw) {
<div class="connection-container selectable-{{!disable_drag}}" id="scale-{{id}}" [style.z-index]="zndx">
  <button matMiniFab id="connector-{{id}}" [class.hidden]="!show_disconnect" (click)="disconnect()"
    (mouseover)="onMouseOver()" (mouseout)="onMouseOut()" aria-label="Example icon button with a menu icon">
    <i class="fas fa-times"></i></button>
</div>
}